import JSZip from 'jszip';
import { IConfigurationContentData } from 'src/types/configuration';

import { decodeCfgText } from './decode-cfg';
import { IDecodedCfgFile } from './types';

export const decodeZipFile = async (
  file: File,
): Promise<IDecodedCfgFile<IConfigurationContentData>[]> => {
  const zip = await JSZip.loadAsync(file);
  const entries = Object.values(zip.files).filter(
    (entry) => !entry.dir && entry.name.toLowerCase().endsWith('.cfg'),
  );

  if (entries.length === 0) {
    throw new Error('ZIP file does not contain any .cfg files');
  }

  return Promise.all(
    entries.map(async (entry, index) => {
      const text = await entry.async('text');
      return decodeCfgText({
        id: `${file.name}-${index}-${entry.name}`,
        fileName: entry.name.split('/').pop() || entry.name,
        text,
      });
    }),
  );
};
